import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const MusicKeyIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			fill="currentColor"
			d="M15 3.18a2 2 0 0 0-2.329-1.972l-7 1.166A2 2 0 0 0 4 4.347V11.8a.2.2 0 0 1-.2.2H2.5c-1 0-1.5.566-1.5 1.351C1 14.261 1.738 15 2.649 15H3.5A2.5 2.5 0 0 0 6 12.5V7.51a.2.2 0 0 1 .167-.198l6.6-1.1A.2.2 0 0 1 13 6.41v4.39a.2.2 0 0 1-.2.2h-1.3c-1 0-1.5.566-1.5 1.351 0 .91.738 1.649 1.649 1.649h.851a2.5 2.5 0 0 0 2.5-2.5V3.18Zm-2.167 2.008A.2.2 0 0 0 13 4.99V3.417a.2.2 0 0 0-.233-.198l-6.6 1.1A.2.2 0 0 0 6 4.517V6.09a.2.2 0 0 0 .233.198l6.6-1.1Z"
		/>
	</svg>
))
